import { render, staticRenderFns } from "./file.vue?vue&type=template&id=057eb29e&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057eb29e",
  null
  
)

export default component.exports